import axios from 'axios';

const consultaCNPJ = axios.create({
	// baseURL: 'https://delphus.cf:21453/api/'
	baseURL: 'https://cors-anywhere.herokuapp.com/http://www.receitaws.com.br/v1/cnpj/',
});

export default consultaCNPJ